export default function PHP_mt_rand() {
  return (
    <div>
      <h1>PHP_mt_rand</h1>
    </div>
  );
}
